import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import "./styles/global.css";
import "./styles/features.css";
import "./styles/site.css";
import "./styles/bunker-art.css";
import "./styles/survivor-art.css";
import "./styles/world-art.css";
import "./styles/cloud.css";
import "./styles/room-operations.css";
import "./styles/scheduling.css";
import "./styles/event-art.css";
import "./styles/accessibility.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 1000 },
    mutations: { retry: 0 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
